// extracted by mini-css-extract-plugin
export var base = "Icon-module--base--c52f4";